import {PlayerType} from "@game/coregame/interfaces/PlayerType";
import {Vector2} from "@game/coregame/interfaces/Vector2";
import {math} from "@game/coregame/helpers/math";
import {Spawner} from "@game/coregame/view/Spawner";

export type Segment = {
    Center: Vector2;
    Width: float;
    Height: float;
    Angle: float;
    Amount: float;
};

export class GroupModel {
    public CreationTimestamp: float;
    public SegmentLen: float;
    public BurstDelay: float;
    constructor(
        public Owner: PlayerType,
        public Speed: float,
        public Amount: float,
        public Path: Vector2[],
        public Target: string,
        public Source: string,
        public TargetAmount: float,
        public LastBurstTimestamp: float
    ) {}

    private _accumulatedLen: float;
    private _maxLen: float;

    public GenerateSegments(segmentAmount: int): Segment[] {
        var segments: Segment[] = [];
        var remainingAmount = this.Amount;

        var lastWidth = 0;

        while (remainingAmount > 0) {
            const updatedAmount = Math.max(remainingAmount - segmentAmount, 0);
            const Amount = remainingAmount - updatedAmount;
            remainingAmount = updatedAmount;

            const Width = (Amount / Spawner.UNITS_PER_WAVE) * this.BurstDelay * this.Speed;
            const Height =
                this.SegmentLen *
                2 *
                (Math.min(Amount, Spawner.UNITS_PER_WAVE) / Spawner.UNITS_PER_WAVE);

            const accumulatedPath = Math.max(this._accumulatedLen - lastWidth, 0);
            const [Center, Angle] = this.TracePath(accumulatedPath);

            segments.push({
                Width,
                Height,
                Angle,
                Center,
                Amount
            });

            lastWidth += Width;
        }

        return segments;
    }

    public get IsReachedEnd(): boolean {
        return this._accumulatedLen >= this._maxLen;
    }
    public Init(timestamp: float, path: float, burstDelay: float, segmentLen: float) {
        this.CreationTimestamp = timestamp;
        this._accumulatedLen = 0;
        this.BurstDelay = burstDelay;
        this.SegmentLen = segmentLen;
        this.CalculateMaxLen();
        this.AccumPath(path);
    }
    CalculateMaxLen(): void {
        let maxLen = 0;
        for (let i = 1; i < this.Path.length; i++) {
            const len = math.dist(this.Path[i - 1], this.Path[i]);
            maxLen += len;
        }

        this._maxLen = maxLen;
    }

    public AccumPath(path: float): void {
        this._accumulatedLen = Math.min(this._accumulatedLen + path, this._maxLen);
    }

    TracePath(path: float): [Vector2, float] {
        let pointPath = 0;
        let center = this.Path[0];
        let angle = math.angle(this.Path[0], this.Path[1]);

        for (let i = 1; i < this.Path.length; i++) {
            const len = math.dist(this.Path[i - 1], this.Path[i]);
            pointPath += len;

            if (pointPath >= path) {
                const lowIndex = i - 1,
                    highIndex = i,
                    highLen = pointPath,
                    lowLen = pointPath - len;

                const t = math.remap(path, lowLen, highLen, 0, 1);
                center = math.lerp(this.Path[lowIndex], this.Path[highIndex], t);
                const dir = math.norm(math.sub(this.Path[highIndex], center));
                const [dx, dy] = dir;
                angle = Math.atan2(dy, dx) * math.RAD2DEG;
                break;
            }
        }

        return [center, angle];
    }
}
